import {cloneDeep, isEmpty} from 'lodash'
import {yup} from 'libs/yup'

// @ts-ignore
import {dependentDefaultValue} from './common'

const hasCarCommutingDistanceTypeSchema = yup
  .object({
    commuting_expenses: yup
      .object({
        car: yup
          .object({
            car_commuting_distance_type: yup.string().notRequired(),
          })
          .required(),
      })
      .required(),
  })
  .strict()

// https://github.com/d-o-n-u-t-s/roumu-server/issues/11185 リリース以前の「片道の通勤距離: 55km以上」を「55km～65km」に変換
const migrateCarCommutingDistanceOver55 = (tmpData: Record<string, unknown>): void => {
  if (
    hasCarCommutingDistanceTypeSchema.isValidSync(tmpData) &&
    tmpData.commuting_expenses.car.car_commuting_distance_type === 'ds_over_55'
  ) {
    tmpData.commuting_expenses.car.car_commuting_distance_type = 'ds_55_65'
  }
}

// https://github.com/d-o-n-u-t-s/roumu-server/issues/11873 リリース以前の家族データに_idを付与
const migrateEnrollDependents = (tmpData: Record<string, unknown>): void => {
  const dependents = tmpData['dependents']

  if (Array.isArray(dependents)) {
    tmpData['dependents'] = dependents.map((dependent) => ({
      ...dependentDefaultValue(),
      ...dependent,
    }))
  }
}

export const migrateTmpData = (tmpData: Record<string, unknown>): Record<string, unknown> => {
  if (isEmpty(tmpData)) {
    return tmpData
  }
  const modifiedData = cloneDeep(tmpData)

  migrateCarCommutingDistanceOver55(modifiedData)
  migrateEnrollDependents(modifiedData)

  return modifiedData
}
